module.exports = __webpack_public_path__ + "static/img/bg.a3da33b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grade/bg.png
// module id = DI8K
// module chunks = 1